import {Injectable} from '@angular/core';
import {EquipmentCardEnums, EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import CardSortingValues = EquipmentCardEnums.CardSortingValues;
import {PagingApiService} from '@abstract/paging-api.service';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {DirectionEnum} from '../enums/direction.enum';


/**
 * Сервис для пагинации карточек оборудования
 */
@Injectable()
export class EquipmentCardPagingApiService extends PagingApiService<EquipmentCardInterfaces.Card.ListItem> {
    protected baseUrl = 'card';

    get pagingUrl() {
        return `${this.baseUrl}/pages`;
    }

    defaultItemsPerPage = 10;

    sortByValues = CardSortingValues;

    sortBy$ = new BehaviorSubject<CardSortingValues|string>(CardSortingValues.title);

    getDefaultFiltersParams(): {} {
        return {
            status: 'allExceptDismiss'
        };
    }

    resetParams() {
        super.resetParams();
        this.sortBy$.next(CardSortingValues.title);
    }
}
